export default __webpack_public_path__ + "static/media/Flaticon2.79370877.svg";